import { render } from "./EditContainer.vue?vue&type=template&id=7128c3f8"
import script from "./EditContainer.vue?vue&type=script&lang=js"
export * from "./EditContainer.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/service_provider/services/container_op/edit_container.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fservice_provider%2Fservices%2Fcontainer_op%2FEditContainer.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/container_scheduled_service.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fservice_provider%2Fservices%2Fcontainer_op%2FEditContainer.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__